var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShieldStroke = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 26,
  viewBox: "0 0 23 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 6.43829C0.75 5.94945 1.10794 5.5315 1.59012 5.45114C4.39257 4.98407 7.04327 3.77534 9.22586 1.95652L10.3955 0.98179C10.7664 0.672752 11.3051 0.672752 11.6759 0.98179L12.8456 1.95652C15.0282 3.77534 17.6789 4.98407 20.4813 5.45114C20.9635 5.5315 21.3214 5.94945 21.3214 6.43829V10.6569C21.3214 16.8455 17.3614 22.3397 11.4904 24.2968C11.1952 24.3951 10.8762 24.3951 10.5811 24.2968C4.71004 22.3397 0.75 16.8455 0.75 10.6569V6.43829Z",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0357 24.4483L11.0357 0.448303",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShieldStroke);
export default ForwardRef;